/**
 * @ngdoc directive
 * @name WebCoreModule.directive:wcNavMenu
 * @restrict A
 * @scope
 * @param {object} menuData The property to assign the menu data into so the view can access it
 * @param {array} menuDataUrl Array of objects defining the menu's structure and text
 * @description
 * The wcNavMenu directive generates a navigation menu from the given menu data url. The url should expose an array of objects
 * defining the menu's structure and text.
 */

angular.module('WebCoreModule')
	.directive('wcNavMenu',  function() { // jshint ignore:line
		return {
			restrict: 'A',
			scope: {
				menuData: '=menuData',
				menuDataUrl: '@menuDataUrl'
			},
			transclude: true,
			template: 	"<nav class=\"navbar navbar-default\" role=\"navigation\">" +
							"<div class=\"container-fluid\">" +
								"<div class=\"navbar-header visible-xxs\">" +
									"<button id=\"toggle-nav-menu-collapse\" type=\"button\" class=\"navbar-toggle collapsed\" ng-click=\"toggleNavbarCollpase($event)\" aria-expanded=\"false\">" +
										"<span class=\"sr-only\">{{'application.navigation.toggleTitle' | translate}}</span>" +
										"<span class=\"icon-bar\"></span>" +
										"<span class=\"icon-bar\"></span>" +
										"<span class=\"icon-bar\"></span>" +
									"</button>" +
								"</div>" +
								"<div uib-collapse=\"navbarCollapsed\" class=\"collapse navbar-collapse\" id=\"primary-nav\" role=\"menu\">" +
									"<ul class=\"nav navbar-nav\">" +
										"<li role=\"menuitem\"  wc-protected-resource=\"{{menu.protected}}\" ng-repeat=\"menu in menuData\" ng-class=\"{dropdown:menu.subMenu}\" ui-sref-active=\"active\">" +
											"<a ng-click=\"collapseNavbar()\" ng-if=\"!menu.subMenu\" ui-sref=\"{{menu.state | translate}}\" ui-sref-opts=\"{reload: true, notify: true}\">" +
												"{{menu.label | translate}}" +
					"						</a>" +
											"<a ng-if=\"menu.subMenu\" ng-click=\"MainMenuCollpase($event)\"  role=\"button\"  aria-expanded=\"false\" href class=\"dropdown-toggle\" data-toggle=\"dropdown\">{{menu.label | translate}}" +
												"<span ng-if=\"menu.subMenu\" class=\"caret\"></span>" +
											"</a>" +
											"<wc-sub-menu></wc-sub-menu>" +
										"</li>" +
									"</ul>" +
									"<span ng-transclude></span>" +
								"</div>" +
							"</div>" +
						"</nav>",
			controller: ['$scope', '$element', '$attrs', '$http',
				function($scope, $element, $attrs, $http) { // jshint ignore:line

					if($scope.menuDataUrl){
						$http.get($scope.menuDataUrl).success(function(response) {
							$scope.menuData = response;
						});
					}

					$scope.$on('$stateChangeStart', function() {

						$('nav .in, nav .open').removeClass('in open');
					});

					$scope.$on('collapseNavBar', function() {
						$scope.collapseNavbar();
					});

					$scope.navbarCollapsed = true;

					$scope.MainMenuCollpase = function(event) {
						event.stopPropagation();
						var nav=$(event.target.parentElement).parent();
						nav.find('li.dropdown,li.dropdown-submenu').not(event.target.parentElement).removeClass("open");
						$(event.target.parentElement).toggleClass("open");
					};

					$scope.toggleNavbarCollpase = function() { // jshint ignore:line
						$scope.navbarCollapsed = !$scope.navbarCollapsed;
					};

					$scope.collapseNavbar = function() { // jshint ignore:line
					};
				}]


		};
	})
	.directive('wcSubMenu', ['$compile', function($compile) {
		return {
			restrict: 'E',
			scope: true,
			link: function(scope, element) {
				//scope.subMenu = scope.menu;

				scope.collapasesubMenu=function(event){
					event.stopPropagation();
					element=event.target.parentElement;
					$( element).toggleClass("open");
				};

				if(scope.menu) {
					var template = angular.element('<ul class="dropdown-menu">' +
														'<li wc-protected-resource="{{menu.protected}}" ng-repeat="menu in menu.subMenu" ng-class=\"{\'dropdown-submenu\':menu.subMenu}\" ui-sref-active=\"active\">' +
															'<a  ng-if=\"!menu.subMenu\" ui-sref="{{menu.state | translate}}" ui-sref-opts="{reload: true, notify: true}">{{menu.label | translate}}</a>' +
															'<a ng-if=\"menu.subMenu\" ng-click=\"collapasesubMenu($event)\" href>{{menu.label | translate}}</a>' +
														'<wc-sub-menu  ng-if=\"menu.subMenu\"></wc-sub-menu>' +
														'</li>' +
													'</ul>');

					var linkFunction = $compile(template);
					linkFunction(scope);
					element.replaceWith(template);
				}
				else {
					element.remove();
				}
			}
		};
	}]);
